var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "h2",
    {
      class: { parent: _vm.parent, "has-completion-type": !!_vm.completionType }
    },
    [
      _vm.completionType
        ? _c(
            "span",
            { class: ["completed-container", _vm.completionType] },
            [_c("Icon", { attrs: { icon: _vm.completionTypeIcon } })],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.hasOneAction
        ? _c(
            "a",
            {
              directives: [{ name: "b-tooltip", rawName: "v-b-tooltip" }],
              staticClass: "text",
              attrs: {
                href: "#",
                title: _vm.isTitleTooLong ? _vm.title : undefined
              },
              on: {
                click: function($event) {
                  $event.preventDefault()
                  return _vm.triggerLoneAction.apply(null, arguments)
                }
              }
            },
            [_vm._v("\n\t\t" + _vm._s(_vm.preparedTitle) + "\n\t")]
          )
        : _c(
            "span",
            {
              directives: [{ name: "b-tooltip", rawName: "v-b-tooltip" }],
              staticClass: "text",
              attrs: { title: _vm.isTitleTooLong ? _vm.title : undefined }
            },
            [_vm._v("\n\t\t" + _vm._s(_vm.preparedTitle) + "\n\t")]
          ),
      _vm._v(" "),
      _vm.tooltip
        ? _c(
            "span",
            {
              directives: [
                {
                  name: "b-tooltip",
                  rawName: "v-b-tooltip.html",
                  modifiers: { html: true }
                }
              ],
              staticClass: "ml-2",
              attrs: { title: _vm.tooltip }
            },
            [_c("Icon", { attrs: { icon: "info" } })],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.editable
        ? _c("span", { staticClass: "edit-container" }, [
            _c(
              "a",
              {
                attrs: { href: "#" },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.$emit("edit")
                  }
                }
              },
              [_c("Icon", { attrs: { icon: "pencil" } })],
              1
            ),
            _vm._v(" "),
            _vm.deletable
              ? _c(
                  "a",
                  {
                    attrs: { href: "#" },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.$emit("delete")
                      }
                    }
                  },
                  [_c("Icon", { attrs: { icon: "bin" } })],
                  1
                )
              : _vm._e()
          ])
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }